import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation UpdateField($params: UpdateFieldInput!) {
    updateField(params: $params) {
      id
    }
  }
`;

export interface FieldParams {
  id: string;
  name?: string;
  currentCrop?: string;
  geometry?: {
    type: 'Polygon';
    coordinates: number[][][];
  };
}

export type UpdateFn = (params: FieldParams) => void;

export type CompletedFn = (field: Field) => void;

interface Result {
  updateField: Field;
}

interface Props {
  onCompleted: CompletedFn;
  children: (
    execute: UpdateFn,
    loading: boolean,
    done: boolean
  ) => React.ReactNode;
}

const UpdateFieldProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={(data: Result) =>
        data ? props.onCompleted(data.updateField) : null
      }
    >
      {(mutateFn, result) =>
        props.children(
          (params: FieldParams) => mutateFn({ variables: { params } }),
          result.loading,
          result.data && result.data.updateField && result.data.updateField.id
        )
      }
    </AuthorizedMutation>
  );
};

export default UpdateFieldProvider;



// WEBPACK FOOTER //
// ./src/providers/UpdateFieldProvider.tsx